import React from "react";
import { Link } from "react-router-dom";

/**
 * Persistent site footer.
 *
 * Owner directive (SEO pass 2026-02-01, §6):
 *   - Renders on every page.
 *   - Navigation links to the site's static pages, the leaderboard,
 *     and the sitemap for crawler discoverability.
 *   - Attribution + unofficial fan-project disclaimer verbatim per spec.
 *
 * The sitemap link points to the root /sitemap.xml (served by the
 * dev-server middleware in preview, hosting rewrite in prod).
 */
export default function Footer() {
  const nav = [
    { to: "/about", label: "About", testid: "footer-about" },
    { to: "/leaderboard", label: "Leaderboard", testid: "footer-leaderboard" },
    { to: "/privacy", label: "Privacy Policy", testid: "footer-privacy" },
    { to: "/terms", label: "Terms of Service", testid: "footer-terms" },
    { href: "/sitemap.xml", label: "Sitemap", testid: "footer-sitemap" },
  ];
  return (
    <footer
      data-testid="site-footer"
      className="mt-16 border-t border-ink-chip bg-ink-bg"
    >
      <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-6 px-5 py-10 md:px-gutter">
        <nav
          aria-label="Site footer"
          data-testid="footer-nav"
          className="flex flex-wrap gap-x-6 gap-y-2 text-meta"
        >
          {nav.map((item) =>
            item.to ? (
              <Link
                key={item.label}
                to={item.to}
                data-testid={item.testid}
                className="text-ink-muted transition-colors duration-cc ease-cc-ease hover:text-ink-text"
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.label}
                href={item.href}
                data-testid={item.testid}
                className="text-ink-muted transition-colors duration-cc ease-cc-ease hover:text-ink-text"
              >
                {item.label}
              </a>
            ),
          )}
        </nav>
        <div
          className="text-meta text-ink-muted"
          data-testid="footer-attribution"
        >
          CardCapture · Reference library · Data from TCGdex
        </div>
        <div
          className="max-w-[62ch] text-meta text-ink-muted"
          data-testid="footer-disclaimer"
        >
          Unofficial fan project. CardCapture is not affiliated with, endorsed
          by, or sponsored by The Pokémon Company, Nintendo, Creatures, or GAME
          FREAK. Pokémon and all associated names are trademarks of their
          respective owners.
        </div>
      </div>
    </footer>
  );
}
